// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__4UZNW","slideImgWrapper":"main_slideImgWrapper__L7yTD","slideimg":"main_slideimg__1JLnM","ulList":"main_ulList__3cNgf"};